import { ElementRef } from '@angular/core';
var ComponentDatestates = (function () {
    function ComponentDatestates(el) {
        this.el = el;
        this.isShowInner = false;
    }
    ComponentDatestates.prototype.ngOnInit = function () {
    };
    ComponentDatestates.prototype.ngOnChanges = function () {
    };
    ComponentDatestates.prototype.ngAfterViewInit = function () {
    };
    return ComponentDatestates;
}());
export { ComponentDatestates };



// WEBPACK FOOTER //
// ./src/component-ui/date-states/component.dateStates.ts.pre-build-optimizer.js